import {
    fetchResponses,
    fetchResponsesFromSource,
    checkItemExists,
    updateMetaTags,
    fetchItemData,
    update_stream,
    get_created_streams,
    get_followed_streams,
    get_stream,
    reversed,
    get_profile
} from "../script.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faHatWizard, faFloppyDisk, faArrowUpFromBracket, faQuestion, faChevronUp, faChevronDown, faChevronLeft, faChevronRight, faSave, faTowerBroadcast, faMagnifyingGlass, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import EditableKindleSlides from '../Util/EditableKindleSlides.js'
import InstantModal from "../Util/InstantModal.js";


import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Button from "react-bootstrap/Button";


export default function Home(props) {
    const navigate = useNavigate();

    const urlParams = new URLSearchParams(useLocation().search);
    const itemGuid = urlParams.get('item');
    const lastGuid = urlParams.get('last');
    const lastIndex = urlParams.get('index');
    const streamGuid = urlParams.get('stream');
    const [isStreamCreator, setisStreamCreator] = useState(false);

    const [query, setquery] = useState();

    const [created_streams, set_created_streams] = useState([]);
    const [followed_streams, set_followed_streams] = useState([]);
    const [streamList, setstreamList] = useState([]);
    const [searchText, setsearchText] = useState("");


    const [showStreamsModal, setshowStreamsModal] = useState(false);
    const [showInfoModal, setshowInfoModal] = useState(false);

    let responseSlides;
    let userInputField;
    let loadingIndicator;
    let spinnerOverlay;

    const [isPlayingAudio, setIsPlayingAudio] = useState(false)
    const [questionSlides, setQuestionSlides] = useState([])
    const [showInstantStreamModal, setShowInstantStreamModal] = useState(false);
    const [isProUser, setIsProUser] = useState(false);

    const [hasSourceStream, sethasSourceStream] = useState(false);
    const [sourceStream, setsourceStream] = useState(null);


    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip">
            {props}
        </Tooltip>
    );

    // TODO: Replace this with proper statefullness once things are more normal
    function setDisplayIfElWithIdExists(elId, displayValue) {
        let el = document.getElementById(elId)
        if (el) {
            el.style.display = displayValue;
        }
    }

    async function navigateBackOnClick(event) {
        // Redirect back after making sure the last GUID is valid
        const itemExists = await checkItemExists(lastGuid);
        if (itemExists) {
            navigate(`/?item=${lastGuid}&index=${lastIndex}`, { replace: true });
            window.location.reload();
        } else {
            alert("Error: item does not exist")
        }
    }

    useEffect(() => {
        let streams = created_streams.concat(followed_streams).filter(obj => {
            let is_vibe_consult = obj.context
            let has_item = false;
            for (let index in obj.items) {
                if (obj.items[index].item == itemGuid) {
                    has_item = true;
                    break;
                }
            }
            return !is_vibe_consult && !has_item;
        })
        // On load reset streams
        setstreamList(streams)
    }, [created_streams, followed_streams]); // Ensure to re-run if loggedInEmail changes

    useEffect(() => {
        // Make sure the email is available before calling get_profile
        if (props.loggedInEmail) {
            // Fetch the profile data using the email prop
            get_profile(props.loggedInEmail).then((profileData) => {
                if (profileData) {
                    // Check if the user is a Pro user based on the profile data
                    setIsProUser(profileData.user_type && profileData.user_type.toLowerCase() === 'pro');
                }
            }).catch(error => {
                console.error('Error fetching profile:', error);
            });
        } else {
            console.error('No email provided');
        }
    }, [props.loggedInEmail]); // Ensure to re-run if loggedInEmail changes


    useEffect(() => {
        const userInputField = document.getElementById('user-input');
        const loadingIndicator = document.getElementById('loading');
        const spinnerOverlay = document.getElementById('spinner-overlay');
        const responseSlides = document.getElementById('response-slides');

        if (itemGuid) {
            console.log("GUID is present");
            fetchItemData(itemGuid, null, loadingIndicator, spinnerOverlay).then(item => {
                console.log(item)
                setQuestionSlides(item);
                if (item.query) {
                    setquery(item.query);
                }
            })
        }

        // ✅ Define handler function for cleanup
        const handleKeyDown = (event) => {
            if (event.key === 'Enter') {
                handleUserInput(event);
            }
        };

        // ✅ Add event listener with null check
        if (userInputField) {
            userInputField.addEventListener('keydown', handleKeyDown);
        }

        // ✅ Define click handler
        let handleInstantClick;
        let instantStreamBtn;

        if (props.loggedInEmail) {
            instantStreamBtn = document.getElementById('btn-instant-stream');
            if (instantStreamBtn) {
                handleInstantClick = async (event) => {
                    setShowInstantStreamModal(true);
                };
                instantStreamBtn.addEventListener('click', handleInstantClick);
            }

            get_created_streams(props.loggedInEmail).then(result => {
                set_created_streams(result);
                // Set stream creator if listed GUID in created streams
                setisStreamCreator(result.some(el => el.guid === streamGuid))
            });
            get_followed_streams(props.loggedInEmail).then(result => {
                set_followed_streams(result);
                for (let fstream in result) {
                    if (result[fstream].context) {
                        sethasSourceStream(true);
                        setsourceStream(result[fstream])
                        break;
                    }
                }
            });
        }

        const urlParams = new URLSearchParams(window.location.search);
        const queryParam = urlParams.get('query');
        if (queryParam) {
            document.title = `6 Hats - ${decodeURIComponent(queryParam)}`;
            if (userInputField) {
                userInputField.value = decodeURIComponent(queryParam);
                userInputField.classList.add('loading');
            }
            if (loadingIndicator) {
                loadingIndicator.style.display = 'inline';
                loadingIndicator.style.margin = 'auto';
            }
            if (spinnerOverlay) {
                spinnerOverlay.style.display = 'inline';
                spinnerOverlay.style.margin = 'auto';
            }
            fetchResponses(queryParam, loadingIndicator, spinnerOverlay, userInputField, navigate);
        }

        const arrowButton = document.querySelector(".arrow-button");

        // Call the function whenever the page content changes
        // Update meta tags when the DOM is fully loaded
        const handleDOMContentLoaded = () => {
            updateMetaTags();
        };

        // Execute updateMetaTags after the DOMContentLoaded event
        document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);

        if (props.loggedInEmail) {
            // This is important as set_add_button_visibility can be slow, so default to hiding the button 
            // unless otherwise specified to prevent it from flashing on screen incorrectly
            setDisplayIfElWithIdExists("btn-add-to-stream", "none");

            // TODO fix this
            if (!props.loggedInEmail) {
                set_add_button_visibility();
            } else if (itemGuid) {
                setDisplayIfElWithIdExists("btn-add-to-stream", "flex");
            }
            setDisplayIfElWithIdExists("btn-new-stream", "none");
        } else {
            // No valid stream
            exit_stream();
        }

        // ✅ CLEANUP FUNCTION - Remove event listeners when component unmounts
        return () => {
            if (userInputField) {
                userInputField.removeEventListener('keydown', handleKeyDown);
            }
            if (instantStreamBtn && handleInstantClick) {
                instantStreamBtn.removeEventListener('click', handleInstantClick);
            }
            document.removeEventListener('DOMContentLoaded', handleDOMContentLoaded);
        };
    }, []);

    async function getQueryFromSource(encodedQuery) {
        let spinnerOverlay = document.getElementById('spinner-overlay');
        let userInputField = document.getElementById('user-input');
        let loadingIndicator = document.getElementById('loading');
        fetchResponsesFromSource(encodedQuery, sourceStream.guid, loadingIndicator, spinnerOverlay, userInputField, navigate).then((item_guid) => {
            console.log(item_guid)
            if (item_guid) {
                update_stream(sourceStream.guid, item_guid, props.loggedInEmail, false).then((resp) => {
                    if (resp) {
                        navigate(`/?item=${item_guid}&stream=${sourceStream.guid}`, { replace: true });
                        window.location.reload();
                    } else {
                        alert("Error adding to stream")
                    }
                })
            }
        })
    }

    const handleUserInput = async function (event) {
        event.preventDefault();
        let userInput = document.getElementById('user-input').value.trim();
        const NAMESPACE_URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8'; // UUIDv5 Namespace URL


        if (userInput !== '') {
            // If adding to source stream
            if (hasSourceStream && document.getElementById("source-switch").checked) {
                getQueryFromSource(encodeURIComponent(userInput))
            } else {
                if (!props.loggedInEmail) {
                    navigate(`/search?query=${userInput}`, { replace: true });
                    window.location.reload();
                } else {
                    /*global uuid*/
                    const guid = uuid.v5(userInput, NAMESPACE_URL);

                    let spinnerOverlay = document.getElementById('spinner-overlay');
                    let userInputField = document.getElementById('user-input');
                    let loadingIndicator = document.getElementById('loading');

                    spinnerOverlay.style.display = 'flex';
                    const encodedQuery = encodeURIComponent(userInput);
                    const responseSlidesPresent = document.getElementById('response-slides');

                    if (responseSlidesPresent) {
                        await fetchResponses(encodedQuery, loadingIndicator, spinnerOverlay, userInputField, navigate);
                    } else {
                        const itemExists = await checkItemExists(guid);
                        if (itemExists) {
                            navigate(`/?item=${guid}`, { replace: true });
                            window.location.reload();
                        } else {
                            await fetchResponses(encodedQuery, loadingIndicator, spinnerOverlay, userInputField, navigate);
                        }
                    }
                }
            }
        }
    };
    function exit_stream() {
        // Stream timed out, change button to new stream
        if (!props.loggedInEmail) {
            setDisplayIfElWithIdExists("btn-view-stream", "none");
        }
        setDisplayIfElWithIdExists("btn-add-to-stream", "none");
        // Only show new stream button if we have a valid item
        setDisplayIfElWithIdExists("btn-new-stream", itemGuid ? "flex" : "none");
    }

    async function set_add_button_visibility() {
        let display_style = "none";
        if (props.tempStream != null && itemGuid) {
            display_style = "flex";
            let streaminfo = await (get_stream(props.tempStream))
            streaminfo.items.forEach(function (entry, index) {
                if (entry.item == itemGuid) {
                    display_style = "none";
                }
            });
        }
        setDisplayIfElWithIdExists("btn-add-to-stream", display_style);
    };

    function displayStreamsOnModal() {
        if (props.loggedInEmail) {
            setshowStreamsModal(true);
        } else {
            if (props.tempStream != null) {
                // Add GUID to stream
                if (itemGuid != null) {
                    update_stream(props.tempStream, itemGuid).then(() => {
                        setDisplayIfElWithIdExists("btn-add-to-stream", "none");
                    });
                }
            } else {
                // Stream timed out, change button to new stream
                alert("error: stream timed out");
                exit_stream();
            }
        }
    }

    async function webShare() {
        // Test compatibility
        if (navigator.share === undefined) {
            console.log('Unsupported share feature');
        }

        // Handle file urls
        let itemUrl = "https://www.6hats.ai/#/?item=" + itemGuid;

        // Share content
        try {
            await navigator.share({ title: "item title", url: itemUrl });
        } catch (error) {
            console.log(`Error sharing: ${error}`);
        }
    }

    return (
        <div className="content-div">
            <InstantModal showModal={showInstantStreamModal} setShowModal={setShowInstantStreamModal} />
            {itemGuid ?
                (questionSlides.data && Object.keys(questionSlides.data).length > 0 ?
                    <EditableKindleSlides
                        slides={questionSlides}
                        allowInstant={(props.tempStream || props.loggedInEmail)}
                        guid={itemGuid}
                        streamGuid={streamGuid}
                        isProUser={isProUser}
                        isStreamCreator={isStreamCreator}
                    /> : null) :
                <div style={{
                    width: "100%",
                    height: "100%",
                    flex: 1,
                    backgroundImage: `url("6hats_background.jpg")`,
                    backgroundPositionX: "50%",
                    backgroundPositionY: "50%",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    boxSizing: "border-box",
                    position: "relative"
                }}>
                    {/* ✅ WIZARD HAT INSTANT STREAM BUTTON - TOP RIGHT */}
                    {props.loggedInEmail ? (
                        <button 
                            id="btn-instant-stream"
                            className="fixed-button"
                            style={{
                                position: "absolute",
                                top: "20px",
                                right: "20px",
                                fontSize: "1.5rem",
                                color: "#A855F7",
                                backgroundColor: "white",
                                border: "2px solid #A855F7",
                                borderRadius: "50%",
                                width: "60px",
                                height: "60px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                boxShadow: "0 4px 12px rgba(168, 85, 247, 0.3)",
                                transition: "all 0.3s ease",
                                zIndex: 1000
                            }}
                            onClick={() => setShowInstantStreamModal(true)}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "scale(1.1)";
                                e.currentTarget.style.boxShadow = "0 6px 16px rgba(168, 85, 247, 0.5)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                                e.currentTarget.style.boxShadow = "0 4px 12px rgba(168, 85, 247, 0.3)";
                            }}
                        >
                            <FontAwesomeIcon icon={faHatWizard} />
                        </button>
                    ) : null}

                    <div className="play-button-container" onClick={() => {
                        let voiceover = document.getElementById("voiceover");
                        if (isPlayingAudio) {
                            voiceover.pause();
                        } else {
                            voiceover.play();
                        }
                        setIsPlayingAudio(!isPlayingAudio);
                    }}>
                        <button className="play-button">
                            {isPlayingAudio ?
                                <i className="fas fa-stop"></i> :
                                <i className="fas fa-play"></i>
                            }
                        </button>
                    </div>
                    <audio id="voiceover" src="mp3/voiceover.mp3" style={{
                        visibility: "hidden"
                    }}></audio>
                </div>
            }


            {itemGuid && (props.tempStream || props.loggedInEmail) ?
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("Save item to stream")}
                >
                    < button className="fixed-button upper-button-2" id="btn-add-to-stream" onClick={() => displayStreamsOnModal()}>
                        <FontAwesomeIcon icon={faFloppyDisk} />
                    </button >
                </OverlayTrigger> : null
            }

            < button className="fixed-button upper-left-button" onClick={() => setshowInfoModal(true)}>
                <FontAwesomeIcon icon={faQuestion} />
            </button >

            {itemGuid ?
                < button className="fixed-button upper-mid-left-button" onClick={() => webShare()}>
                    <FontAwesomeIcon icon={faArrowUpFromBracket} />
                </button > : null
            }
            {itemGuid && streamGuid ?
                <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("Back to stream")}
                >
                    < button className="fixed-button upper-lower-left-button" onClick={() => {
                        navigate(`/s/${streamGuid}?item=` + itemGuid, { replace: true });
                    }}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button >
                </OverlayTrigger > : null
            }

            {lastGuid && lastIndex ?
                <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("Back to previous item")}
                >
                    < button className="fixed-button upper-lower-left-button" onClick={() => { navigateBackOnClick() }}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button >
                </OverlayTrigger > : null
            }

            {/*<!-- Text box container fixed at the bottom of the page -->*/}
            <div className="textbox-container" style={{ display: "flex", flexDirection: "column" }}>
                <hr style={{ width: "100%", margin: "0px" }} />

                <div>
                    {hasSourceStream ?
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltip("Get answers to your question from the source stream context")}
                        >
                            <div class="form-check form-switch" style={{ marginTop: "5px", marginLeft: "10px", float: "left" }}>
                                <input class="form-check-input" type="checkbox" role="switch" id="source-switch" defaultChecked={true} />
                                <label class="form-check-label" for="source-switch">Query my active source stream</label>
                            </div>
                        </OverlayTrigger> : null
                    }
                </div>
                <textarea id="user-input" rows="2" placeholder="6Hats – AI answers. You save. Experts bring nuance."></textarea>
                {/*<!-- Upward arrow button on the right side -->*/}
                <button className="arrow-button" id="btn-query" onClick={handleUserInput}>
                    {props.loggedInEmail ?
                        <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faMagnifyingGlass} />
                    }
                </button>
            </div >

            <span id="loading" className="center-screen" style={{ display: "none" }}>Loading...</span>

            {/*<!-- Spinner overlay -->*/}
            <div id="spinner-overlay" className="spinner-overlay" style={{ display: "none" }}>
                <i className="fas fa-spinner fa-spin fa-3x" style={{ color: "gray" }}></i>
            </div>

            <Modal show={showStreamsModal} onHide={() => setshowStreamsModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Select stream to save item in</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <input id="inputsearch" placeholder="Enter text to search stream titles" className="stream-table-center" style={{ padding: "10px", fontSize: "16px", border: "1px solid #888", borderRadius: "5px", width: "100%", marginBottom: "5px"}}
                        onInput={() => { setsearchText(document.getElementById("inputsearch").value) }} />
                    {/*<!-- Modal content -->*/}
                    <div className="modal-content scrollable">
                        {reversed(streamList.filter(obj => {
                            // Do search, and filter any streasm which already contain this item
                            return !searchText || obj.title.toLowerCase().includes(searchText.toLowerCase());
                        })).map((stream, i) => {
                            return stream.by != "Automatic" ?
                                <Card style={{ margin: "5px" }} className={'stream-table-row ' + (i % 2 != 0 ? 'dark-background' : '')} onClick={async function () {
                                    let result = await update_stream(stream.guid, itemGuid, props.loggedInEmail);
                                    if (result) {
                                        navigate("/s/" + stream.guid, { replace: true });
                                    } else {
                                        alert("Add to stream failed");
                                    }
                                }} >
                                    <h6> {stream.title} </h6>
                                    <div style={{ display: "flex" }}>
                                        <p style={{ marginRight: ".25rem" }}>created by: </p>
                                        <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={renderTooltip(stream.by)}>
                                            <p>{stream.by.split("@")[0]}</p>
                                        </OverlayTrigger>
                                    </div>
                                </Card> : null
                        })}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => setshowStreamsModal(false)} variant="secondary">Cancel</Button>
                </Modal.Footer>
            </Modal >

            <Modal show={showInfoModal} onHide={() => setshowInfoModal(false)}>
                <Modal.Header closeButton>
                    <h3>Help</h3>
                </Modal.Header>
                <Modal.Body>
                    <p>Enter your query in the box below, then click the up arrow button (<FontAwesomeIcon icon={faArrowUp} />) to generate a response.</p>
                    {itemGuid ?
                        <>
                            <p>Navigate the responses by tapping/clicking on the left or right side of the screen, swiping, or (on a desktop computer) using the left and right arrows (<FontAwesomeIcon icon={faChevronLeft} />, <FontAwesomeIcon icon={faChevronRight} />). Bring up the list of responses to your query by tapping the center of the screen.</p>
                            {/* <p>Dig deeper into the responses with the tell me more feature by swiping down or clicking the down arrow (<FontAwesomeIcon icon={faChevronDown} />) on any response past the first page. Return to the original item by swiping up or using the up arrow (<FontAwesomeIcon icon={faChevronUp} />). </p> */}
                        </> : null
                    }
                    {props.loggedInEmail ? (
                        <p>
                            View your streams and vault from the Channels page by clicking the channels icon
                            (<FontAwesomeIcon icon={faTowerBroadcast} />). Save the active item to any of your joined streams
                            with the save icon (<FontAwesomeIcon icon={faSave} />).
                        </p>
                    ) : null}
                </Modal.Body>
            </Modal >
        </div>
    );
}